/**
 * Utilitários para a lógica de sincronização de rede no envio (TransferForm).
 * Usado para: leitura fresca de eth_chainId, decisão de bloquear por mismatch, etc.
 */

/**
 * Normaliza chainId para forma canônica (0x + hex minúsculas).
 * Usado para comparação e como chave em mapas (RPC, stablecoins).
 * @param {string|number|undefined|null} value
 * @returns {string|null}
 */
export function normalizeChainId(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'number') return '0x' + value.toString(16);
  const s = String(value).trim().toLowerCase();
  if (s === '') return null;
  return s.startsWith('0x') ? s : '0x' + s;
}

/**
 * Retorna o chainId efetivo da carteira após uma leitura fresca (eth_chainId).
 * Se a leitura fresca existir, ela prevalece; senão usa o valor do estado.
 * Assim, quando o usuário já trocou no MetaMask e o estado ainda não atualizou,
 * consideramos a rede atual (não bloqueamos por mismatch).
 * @param {string|null} walletChainIdFromState - chainId que a app tem no estado
 * @param {string|number|null|undefined} freshChainIdFromProvider - retorno de provider.request('eth_chainId')
 * @returns {string|null}
 */
export function getEffectiveWalletChainId(walletChainIdFromState, freshChainIdFromProvider) {
  const fresh = normalizeChainId(freshChainIdFromProvider);
  if (fresh) return fresh;
  return normalizeChainId(walletChainIdFromState);
}

/**
 * Indica se há mismatch de rede: carteira (efetiva) diferente da rede selecionada na app.
 * Quando true, o fluxo de envio deve bloquear (ou tentar switch e depois revalidar).
 * @param {string|null} effectiveWalletChainId - chainId efetivo da carteira (após leitura fresca)
 * @param {string|null} selectedChainId - chainId da rede selecionada na aplicação
 * @returns {boolean}
 */
export function isNetworkMismatch(effectiveWalletChainId, selectedChainId) {
  if (!effectiveWalletChainId || !selectedChainId) return false;
  return effectiveWalletChainId !== selectedChainId;
}
